// Components
import Heading from '@/components/atoms/Heading/Heading';
import PreTitle from '@/components/atoms/PreTitle/PreTitle';
import Markdown from '@/components/atoms/Markdown/Markdown';
import CmsImage from '@/components/atoms/CmsImage/CmsImage';

// Other
import { type SectionAvantages2Type } from '@/services/blocksSchema';
import CheckRedIcon from '@/assets/icons/check-red.svg?react';

// Style
import styles from './SectionAvantages2.module.css';

interface SectionAvantages2Props {
  preTitle: SectionAvantages2Type['preTitle'];
  title: SectionAvantages2Type['title'];
  cards: SectionAvantages2Type['cards'];
}

function SectionAvantages2({
  preTitle,
  title,
  cards,
}: SectionAvantages2Props) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <PreTitle
          preTitle={preTitle}
          size='p1'
          color='dark'
        />
        <Heading
          title={title}
          size='h2'
          Tag='h2'
          color='dark'
          align='center'
        />
      </div>
      <div className={styles.cards}>
        {
          cards.map((card) => (
            <div key={card.title} className={styles.card}>
              <div className={styles['card-body']}>
                <div className={styles['card-body-icon']}>
                  <CmsImage
                    media={card.icon}
                    sizes="(max-width: 1024px) 100vw, 50vw"
                  />
                </div>
                <Heading
                  title={card.title}
                  size='h4'
                  Tag='h4'
                  color='dark'
                />
                <Markdown
                  text={card.description}
                  className={styles['card-description']}
                />
              </div>
              <div className={styles['card-footer']}>
                <CheckRedIcon className={styles['card-footer-icon']} />
                <p className={styles['card-footer-text']}>
                  {card.text}
                </p>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}

export default SectionAvantages2;
